module.exports = __webpack_public_path__ + "static/melinda-6b8aa5c40d6bd6b08d3b04639e5fbcfd.jpg";